import React from 'react';
import ArrowLink from '@boschebike/ebds-react/dist-esm/components/ArrowLink.js';
import { BoschIconAsChunk } from '../../ebds/iconProvider.js';
import { RawElement } from '../helpers.js';

/**
 * @typedef {import('../../App.d.ts').ServiceBenefitItemProps} ServiceBenefitItemProps
 */
/**
 * @param {ServiceBenefitItemProps} props
 */
export default (props) => {
  return (
    <div
      data-testid="service-benefit-item"
      className="ebds-service-benefit-item"
    >
      <div className="ebds-service-benefit-item__content">
        <h4>{props.fields.headline}</h4>
        <RawElement html={props.fields.descriptionRaw} />
        {props.fields?.button ? (
          <ArrowLink
            text={props.fields.button.label}
            href={props.fields.button.href}
          />
        ) : null}
      </div>
      <div className="ebds-service-benefit-item__icon">
        <BoschIconAsChunk iconName={props.fields.icon} />
      </div>
    </div>
  );
};
